<div class="modal-content">
    <div class="modal-header">
        <h3 class="modal-title pull-left" id="my-modal-title">{{'REPORT_CHANGE_POPUP_TITLE' | globalTranslate}}</h3>
        <button type="button" class="btn-close pull-right" [attr.aria-label]="'CLOSE' | globalTranslate" (click)="onCancel()">
            <img src="../../assets/images/⚛️ icons-close-circle-outline.svg" alt="close-icon"/>
        </button>
    </div>
    <div class="modal-body">
        <p [innerHTML]="'REPORT_CHANGE_POPUP_DESC' | globalTranslate"></p>
    </div>
    <div class="modal-footer d-block">
        <div class="action-container" >
            <button type="button" id="dialog" class="btn btn-block btn-secondary btn-start" (click)="updateMyInformation()" [disabled]="readTCC">{{'UPDATE_MY_INFORMATION' | globalTranslate}}</button>
        </div>
    </div>
</div>